import React from "react";

export default function QualificationDropdown({
  value,
  onChange,
  required = false,
  showLabel = true,
  error,
}) {
  const qualifications = ["SSCE", "NCE", "Diploma", "HND", "Degree", "Masters", "PhD"];

  return (
    <div className="mb-4">
      {/* Show label only if showLabel is true */}
      {showLabel && (
        <label className="block font-medium mb-1">
          Highest Qualification {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className={`w-full border rounded-md px-3 py-2 focus:ring-2 focus:ring-green-400 focus:border-green-400 outline-none transition ${
          error ? "border-red-500" : "border-gray-300"
        }`}
      >
        {/* Placeholder adjusts if label is hidden */}
        <option value="">{showLabel ? "Select Qualification" : "Qualification"}</option>
        {qualifications.map((q) => (
          <option key={q} value={q}>
            {q}
          </option>
        ))}
      </select>

      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
}
